import { gql } from '@apollo/client';

const CurrentUserQuery = gql`
  query WarRoomCurrentUser {
    currentUser {
      id
      city {
        id
        name
        countryCode
        stateCode
      }
      departments {
        id
        name
      }
      productTypes {
        id
        name
      }
      username
      warRoomState
      warRoomAvatarUrl
      warRoomDescription
      warRoomPosition
      warRoomSalesRoles {
        id
        name
      }
      warRoomYearsOfExperience
    }
  }
`;

export default CurrentUserQuery;
